import { render } from "./SidebarFooter.vue?vue&type=template&id=f6046704&ts=true"
import script from "./SidebarFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarFooter.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6046704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6046704', __exports__)) {
    api.reload('f6046704', __exports__)
  }
  
  module.hot.accept("./SidebarFooter.vue?vue&type=template&id=f6046704&ts=true", () => {
    api.rerender('f6046704', render)
  })

}


export default __exports__